import cc from 'classcat';
import { ChangeEvent } from 'react';

interface TextAreaProps {
    id: string;
    placeholder?: string;
    label?: string;
    isRequired?: boolean;
    value: string;
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    className?: string;
    maxLength?: number;
}

export const TextArea = ({ id, placeholder, label, isRequired, value, onChange, className, maxLength }: TextAreaProps) => {
    return (
        <div className={cc(['text-area', className])}>
            {label && (
                <label className="text-area__label paragraph-4">
                    {label}
                    {isRequired ? <span className="text-area_is_req">*</span> : ''}
                </label>
            )}
            <textarea
                className="text-area__field"
                id={id}
                name={id}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                maxLength={maxLength}
            />
        </div>
    );
};
